define( function() {
	return ( /^(?:checkbox|radio)$/i );
} );



//////////////////
// WEBPACK FOOTER
// /var/www/html/themes/base/node_modules/jquery/src/manipulation/var/rcheckableType.js
// module id = 61
// module chunks = 8